import Vue from 'vue'
import Router from 'vue-router'

import aboutRoutes from './about'
import extraRoutes from './extra'
import basicRoutes from './basic'
import platformRoutes from './platform'
import applicationRoutes from './application'
import downloadRoutes from './download'
import developRoutes from './develop'
import customerRoutes from './customer'
import homeRoutes from './home'
import solutionRoutes from './solution'
import errorRoutes from './error'
import main from '@/views/Main'
Vue.use(Router)

const children = [...aboutRoutes, ...extraRoutes, ...customerRoutes, ...homeRoutes, ...solutionRoutes, ...basicRoutes, ...platformRoutes,
  ...applicationRoutes, ...downloadRoutes, ...developRoutes
]
const router = new Router({
  mode: 'history',
  base: "portal-web",
  routes: [{
      path: '/',
      name: '',
      component: main,
      children
    },
    ...errorRoutes
  ]
})

router.beforeEach((to, from, next) => {
  window.scroll(0, 0);
  next();
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js